import { Link, useLocation } from "react-router-dom";
import { useMount } from "react-use";

import { Icon, RenderWhen } from "../../../../../../components";
import { DataBlock } from "../data-blocks";
import { SelectLayout } from "../select-layout";

import { useStorage } from "../../../../../../hooks";
import { isAdmin } from "../../../../../../utils";
import { DataBlockItem } from "../../@types";
import { useNavigationBlockContext } from "../../hooks";
import styles from "./sidebar.module.scss";

const admin = isAdmin();

type Props = {
  components: Array<DataBlockItem>;
  onAddClick: (id: string) => void;
};

const SideBar = ({ components, onAddClick }: Props) => {
  const { state } = useLocation();

  const { api, dirty } = useNavigationBlockContext();
  const [referrer, setReferrer] = useStorage("samples_layout_referrer");

  useMount(() => {
    if (state?.from) {
      setReferrer({ referrer: state.from });
    }
  });

  const handleBackClick = () => {
    if (!dirty) return;
    api.setLeaveMessage(
      "There are unsaved changes. Are you sure you want to discard them and leave Layout Editor?"
    );
  };

  const handleNewLayoutClick = () => {
    if (!dirty) return;
    api.setLeaveMessage(
      "There are unsaved changes. Are you sure you want to discard them and open a new empty layout?"
    );
  };

  return (
    <>
      <aside className={styles.sidebar}>
        <Link
          data-testid="back-button"
          reloadDocument={referrer?.referrer?.includes("admin") && admin}
          className={styles.back}
          onClick={handleBackClick}
          to={referrer?.referrer ?? "/"}
        >
          <Icon name="arrow-left" />{" "}
          <span className={styles.back_text}>Back</span>
        </Link>
        <div className={styles.sidebar_menu}>
          <div className={styles.header}>
            <span className={styles.title}>Manage Layout Mode</span>
          </div>
          <div className={styles.layout}>
            <div className={styles.select_layout}>
              <span>Layouts:</span>
              <SelectLayout />
            </div>
            <Link
              to="create"
              className={styles.new_layout}
              onClick={handleNewLayoutClick}
            >
              Create New Layout
            </Link>
            <div className={styles.available_data_blocks}>
              <span>Available Data Blocks:</span>
              <div
                data-testid="available-data-blocks"
                className={styles.data_blocks}
              >
                <RenderWhen
                  condition={Boolean(components.length)}
                  fallback={
                    <span className={styles.data_blocks_empty}>
                      No Available Components
                    </span>
                  }
                >
                  {components.map(item => (
                    <DataBlock
                      key={item.id}
                      id={item.id}
                      title={item.title}
                      note={item.note}
                      description={item.description}
                      onAddClick={() => {
                        onAddClick(item.id);
                      }}
                    />
                  ))}
                </RenderWhen>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default SideBar;
